import React, { useEffect, useState } from "react";
import { IoCheckmarkCircle } from "react-icons/io5";
import "./puja-campaign-bg.scss";
import Image from "next/image";

import { getAllBg } from "@/customHooks/campaign/durgaPuja2025/getAllBg.js";

import Btn from "../btn";
import { toast } from "react-toastify";

const toastOptions = {
  position: "top-left",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "light",
};

export default function Bg({ onNextComp, setBgId }) {
  const [bgImages, setBgImages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedBg, setSelectedBg] = useState(null);

  // Fetch background images on component mount
  useEffect(() => {
    const bgs = async () => {
      setIsLoading(true);

      const bgs = await getAllBg();

      if (!bgs) {
        toast.error(
          "Failed to load background images. Please try again later.",
          toastOptions
        );
        setIsLoading(false);
        return;
      }

      setBgImages(bgs);
      setIsLoading(false);
    };

    bgs();
  }, []);

  // Handle select background and proceed to next component
  const handleSelectBg = () => {
    if (!selectedBg) {
      toast.warning("Please select a background", toastOptions);
      return;
    }

    setBgId(selectedBg);
    onNextComp("camera");
  };

  return (
    <div className="flex-col-center PujaCampaignBg">
      <h1 className="pageHeading">SELECT YOUR PANDAL</h1>

      {isLoading ? (
        <span className="flex-row-center campaignBgLoader"></span>
      ) : (
        <div className="flex-row-center campaignBgImageGrid">
          {bgImages?.map((item) => {
            return (
              <div
                key={item._id}
                className="flex-row-center singleBgCardCampaign"
                onClick={() => setSelectedBg(item._id)}
              >
                {selectedBg === item._id && (
                  <IoCheckmarkCircle
                    className="selectedIconCampaign"
                    color="white"
                  />
                )}
                <Image
                  src={item.cardUrl}
                  width={100}
                  height={100}
                  className="imageBgCampaign"
                  alt="bg image"
                />
              </div>
            );
          })}
        </div>
      )}
      {!isLoading && (
        <Btn
          btnTxt={"SELECT"}
          onClick={handleSelectBg}
          isLoading={false}
          isBigBtn={false}
        />
      )}
    </div>
  );
}
